export default "__VITE_ASSET__ekXP7uf5__"